enum SuperCalculationMethod {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE_OF_GROSS_WAGES = 'PERCENTAGE_OF_GROSS_WAGES'
}

export default SuperCalculationMethod;
